import {
  confirmVillage,
  confirmStructure,
  addEvaluating,
  optionList,
  confirmSpace,
  getDemand,
  styleProgramList,
  getLabels,
  spaceProgramList,
  spaceProgramDetail,
  styleProgramDetail,
  markLoveStyle,
  markLoveSpace,
  customerProgram,
  preSchedule
} from '@/api/design.js'

const state = {
  labels: ''
}

const mutations = {
  SET_LABELS(state, labels) {
    state.labels = labels
  }
}

const actions = {
  // 获取权限列表
  confirmVillage({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      confirmVillage(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  confirmStructure({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      confirmStructure(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  addEvaluating({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      addEvaluating(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  optionList({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      optionList(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getDemand({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getDemand(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  confirmSpace({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      confirmSpace(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  styleProgramList({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      styleProgramList(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  spaceProgramList({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      spaceProgramList(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  spaceProgramDetail({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      spaceProgramDetail(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  styleProgramDetail({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      styleProgramDetail(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  markLoveStyle({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      markLoveStyle(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  markLoveSpace({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      markLoveSpace(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  customerProgram({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      customerProgram(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  preScheduleNet({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      preSchedule(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getLabels({ commit, state }, data) {
    if (state.labels) {
      return Promise.resolve(state.labels)
    }
    return new Promise((resolve, reject) => {
      getLabels(data)
        .then(res => {
          resolve(res.data.data)
          commit('SET_LABELS', res.data.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
